import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import { LocalizableMessage, LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { DESIGN_SYSTEM, SEARCH_ICONS } from 'constants/icons';
import { SEARCHBOX_THEMES } from './SearchBox.constants';
import { messages } from './SearchBox.messages';
import { LocationFieldContainer } from './LocationFieldContainer';
import { KeywordFieldContainer } from './KeywordFieldContainer';
export var SearchBox =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SearchBox, _PureComponent);

  function SearchBox() {
    _classCallCheck(this, SearchBox);

    return _possibleConstructorReturn(this, _getPrototypeOf(SearchBox).apply(this, arguments));
  }

  _createClass(SearchBox, [{
    key: "renderSearchPanelCollapsed",
    value: function renderSearchPanelCollapsed() {
      var _this$props = this.props,
          isMapView = _this$props.isMapView,
          keywordText = _this$props.keywordText,
          locationText = _this$props.locationText,
          onClickCollapsedSearchBar = _this$props.onClickCollapsedSearchBar,
          onToggleMapView = _this$props.onToggleMapView,
          selectedVertical = _this$props.selectedVertical,
          shouldShowViewToggler = _this$props.shouldShowViewToggler;
      var text = keywordText || selectedVertical && React.createElement(LocalizableMessage, {
        message: messages[selectedVertical]
      }) || '';
      return React.createElement("div", {
        className: "searchbox__collapsed"
      }, React.createElement("div", {
        className: "searchbox__collapsed__field-info",
        onClick: onClickCollapsedSearchBar
      }, React.createElement(Isvg, {
        src: DESIGN_SYSTEM.lookingGlass
      }), React.createElement("b", null, text), React.createElement("span", {
        className: "color-text-light"
      }, React.createElement(LocalizableMessage, {
        message: locationText
      }))), shouldShowViewToggler && React.createElement("div", {
        className: "searchbox__collapsed__view-toggler",
        onClick: onToggleMapView
      }, React.createElement(Isvg, {
        src: isMapView ? SEARCH_ICONS.listview : SEARCH_ICONS.mapview
      })));
    }
  }, {
    key: "renderSearchPanelExpanded",
    value: function renderSearchPanelExpanded() {
      var _this$props2 = this.props,
          isKeywordOpen = _this$props2.isKeywordOpen,
          isKeywordOpenOnMobile = _this$props2.isKeywordOpenOnMobile,
          isLocationOpen = _this$props2.isLocationOpen,
          isLocationOpenOnMobile = _this$props2.isLocationOpenOnMobile,
          isPanelOpen = _this$props2.isPanelOpen,
          isPanelOpenOnMobile = _this$props2.isPanelOpenOnMobile,
          onPanelClose = _this$props2.onPanelClose;
      return React.createElement("div", {
        className: classNames('searchbox__controls', {
          'searchbox__controls--open': isPanelOpen
        })
      }, isPanelOpenOnMobile && React.createElement("div", {
        className: "searchbox__controls__close",
        onClick: onPanelClose
      }, React.createElement(Isvg, {
        src: SEARCH_ICONS.back
      })), React.createElement("div", {
        className: "searchbox__controls__fields"
      }, React.createElement(KeywordFieldContainer, {
        isOpen: isKeywordOpen,
        isOpenPanelOnMobile: isKeywordOpenOnMobile
      }), React.createElement(LocationFieldContainer, {
        isOpen: isLocationOpen,
        isOpenPanelOnMobile: isLocationOpenOnMobile
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props3 = this.props,
          isHidden = _this$props3.isHidden,
          isInHeader = _this$props3.isInHeader,
          isPanelOpenOnMobile = _this$props3.isPanelOpenOnMobile,
          isSearchPanelCollapsed = _this$props3.isSearchPanelCollapsed,
          theme = _this$props3.theme;
      return React.createElement("div", {
        className: classNames('searchbox', (_classNames = {
          'searchbox--header': isInHeader,
          'searchbox--panel-open': isPanelOpenOnMobile
        }, _defineProperty(_classNames, "searchbox--theme-".concat(theme), Object.values(SEARCHBOX_THEMES).includes(theme)), _defineProperty(_classNames, "hidden", isHidden), _classNames))
      }, isSearchPanelCollapsed ? this.renderSearchPanelCollapsed() : this.renderSearchPanelExpanded());
    }
  }]);

  return SearchBox;
}(PureComponent);
SearchBox.propTypes = {
  isHidden: PropTypes.bool,
  isInHeader: PropTypes.bool,
  isKeywordOpen: PropTypes.bool,
  isKeywordOpenOnMobile: PropTypes.bool,
  isLocationOpen: PropTypes.bool,
  isLocationOpenOnMobile: PropTypes.bool,
  isMapView: PropTypes.bool,
  isPanelOpen: PropTypes.bool,
  isPanelOpenOnMobile: PropTypes.bool,
  isSearchPanelCollapsed: PropTypes.bool,
  keywordText: PropTypes.string.isRequired,
  locationText: LocalizableMessageShape.isRequired,
  onClickCollapsedSearchBar: PropTypes.func.isRequired,
  onPanelClose: PropTypes.func.isRequired,
  onToggleMapView: PropTypes.func.isRequired,
  selectedVertical: PropTypes.string,
  shouldShowViewToggler: PropTypes.bool,
  theme: PropTypes.string
};